export default "__VITE_ASSET__17e8d0f3__"